<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-notice`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.1222 2.45918C10.9784 1.0449 13.0298 1.04481 13.8859 2.45918L14.3224 3.18184C17.703 4.26071 20.0234 7.40747 20.0236 10.9875V11.8977C20.0237 13.7555 20.7456 15.5409 22.0363 16.8771L22.6408 17.5031C22.9196 17.7917 22.9997 18.2197 22.8429 18.5891C22.6861 18.9583 22.3232 19.1984 21.922 19.1984H15.9718C15.6769 21.1247 14.0118 22.5998 12.0031 22.5998C9.99456 22.5996 8.3301 21.1245 8.03531 19.1984H2.07828C1.67673 19.1984 1.31401 18.9578 1.15738 18.5881C1.00082 18.2184 1.08031 17.7906 1.35953 17.5021L1.96597 16.8762C3.26007 15.5401 3.98453 13.7528 3.98453 11.8928V10.9875C3.9846 7.40804 6.3041 4.26119 9.68375 3.18184L10.1222 2.45918Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillNotice',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
